import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    intervalMs: { type: Number, default: 2000 }
  }  

  connect() {
    // The typical pattern is to render a <turbo-frame> with a spinner as the initial contents.
    // Every subsequent reload of the src URL will cause the frame to re-render.
    // This means that to avoid some visual jank, each response to polling needs to re-render 
    // that same spinner markup until the final "success" response is rendered.

    // I wanted to conditionally cancel rendering based on the response code, but haven't found
    // a way to do that with the limited events that Turbo triggers.
    // The workaround here is to just not replace the contents of the frame if the new contents
    // are empty.
    this.element.addEventListener("turbo:before-frame-render", (event) => {
      var originalRender = event.detail.render
      event.detail.render = (currentElement, newElement) => {
        if (newElement.innerHTML.trim().length > 0) {
          originalRender(currentElement, newElement)
        }
      }
    })
  
    this.element.addEventListener("turbo:frame-render", (event) => {
      const statusCode = event.detail.fetchResponse.statusCode;

      // If we get a 202: Accepted back, we take that to mean the server has accepted a "task"
      // for processing but hasn't finished yet. We'll keep reloading until we get a different
      // status.
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/202
      if (statusCode === 202) {
        this.timeout = setTimeout(() => {
          this.element.reload(); // https://turbo.hotwired.dev/reference/frames#functions
        }, this.intervalMsValue);
      }
    })
  }

  disconnect() {
    // make sure we stop any pending reloads
    clearTimeout(this.timeout);
  }   
}

